import styles from './ProductPrice.module.scss';
import React from 'react';

const ProductPrice = ({ product }) => {
  const regularPrice = !!product?.regularPrice ? product.regularPrice : product.salePrice;
  const salePrice = !!product?.salePrice && product.salePrice != regularPrice ? product.salePrice : null;

  return (
    <>
      {!!salePrice && (
        <p className={styles.salePriceWrapper}>
          <span className={`${styles.productSalePrice} ${styles.productMainPrice}`}>{product.salePrice}</span>
          {!!product?.currency && <span className={styles.productCurrencySale}>{product.currency}</span>}
          {!!product?.currencySuffix && <span className={styles.productCurrencySale}>{product.currencySuffix}</span>}
        </p>
      )}
      <p className={`${styles.regularPriceWrapper} ${!salePrice ? '' : styles.crossedPrice}`}>
        {!!regularPrice && (
          <span className={`${styles.productRegularPrice} ${!salePrice ? styles.productMainPrice : styles.crossPrice}`}>{regularPrice}</span>
        )}
        {!!product?.currency && <span className={`${styles.productCurrency} ${!!salePrice ? styles.crossPrice : ''}`}>{product.currency}</span>}
        {!!product?.currencySuffix && (
          <span className={`${styles.productCurrency} ${!!salePrice ? styles.crossPrice : ''}`}>{product.currencySuffix}</span>
        )}
      </p>
    </>
  );
};
export default ProductPrice;
